import { useQuery } from "react-query";
import { getFamilyNavigators } from "api/users";
import { GET_FAMILY_NAVIGATORS } from "@constants/reactQueryKeys";

interface UseGetFamilyNavigatorsOptions {
  enabled?: boolean;
}

export const useGetFamilyNavigators = ({ enabled = true }: UseGetFamilyNavigatorsOptions = {}) => {
  const { data, isLoading, ...rest } = useQuery(
    [GET_FAMILY_NAVIGATORS],
    async () => {
      const response = await getFamilyNavigators();
      return response.data || [];
    },
    { enabled },
  );

  return {
    familyNavigators: data || [],
    familyNavigatorsLoading: isLoading,
    ...rest,
  };
};

export default useGetFamilyNavigators;
